import styled from 'styled-components'

export const StyledHeader = styled.div`
  min-height: 0;
`
export const StyledTitle = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  text-transform: uppercase;
`
export const StyledDescription = styled.p`
  font-size: 1.2rem;
  font-weight: 400;
  color: var(--color-gray-106);
`
